import syncApi, { clearSessionToken, setSessionToken } from './syncApi';

/*
 * Authentication + user directory client.
 *
 * Sign-in is passwordless: request a link, the backend emails it, and its
 * callback redirects here with the session token in the URL fragment. The
 * token then rides on every request as an Authorization header (see syncApi).
 */

export const requestMagicLink = (email, redirectTo) =>
  syncApi.post('/auth/magic-link', { email, redirect_to: redirectTo }).then((r) => r.data);

export const getMe = () => syncApi.get('/auth/me').then((r) => r.data);

export const logout = () =>
  syncApi
    .post('/auth/logout')
    .catch(() => null)
    .finally(() => clearSessionToken());

export const adoptSession = (token) => setSessionToken(token);

// ── Directory administration (admin only) ──
export const listRoles = () => syncApi.get('/auth/roles').then((r) => r.data);
export const listUsers = () => syncApi.get('/auth/users').then((r) => r.data);
export const createUser = (payload) => syncApi.post('/auth/users', payload).then((r) => r.data);
export const updateUser = (id, payload) => syncApi.put(`/auth/users/${id}`, payload).then((r) => r.data);
export const replaceUserRoles = (id, roles) =>
  syncApi.put(`/auth/users/${id}/roles`, { roles }).then((r) => r.data);
